// extracted by mini-css-extract-plugin
export default {"mainButton":"styles_mainButton__76MqG","innerButton":"styles_innerButton__oyXPQ","btnGroup":"styles_btnGroup__Td588"};